import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "chat-markdown",
    innerHTML: $setup.html
  }, null, 8 /* PROPS */, _hoisted_1))
}